import { render } from "./singleImg.vue?vue&type=template&id=da221084&scoped=true"
import script from "./singleImg.vue?vue&type=script&lang=js"
export * from "./singleImg.vue?vue&type=script&lang=js"

import "./singleImg.vue?vue&type=style&index=0&id=da221084&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da221084"]])

export default __exports__